<mat-progress-bar mode="indeterminate" class="global-progress-bar" [class.visible]="isProgressBarActive$ | async"></mat-progress-bar>